import { SystemLocale } from '@ninja/utilities';
import { GetQuoteListResponse } from '@shory-health-individual/customer-api';
import { AppInit } from '../../../../server';

export const getNetworkCount = (
	planNetworkCounts: GetQuoteListResponse['quotePlans'][number]['planDetails']['planNetworkCounts'],
	locale: SystemLocale
) => {
	const displayNetworks = planNetworkCounts.filter((n) => n.display);
	const { getFacilityById } = new AppInit(locale);

	return displayNetworks
		?.map((network) => {
			const facilityName = getFacilityById(network.facilityTypeId)?.name ?? '';

			return { ...network, facilityName };
		})
		.sort((a, b) => (a.facilityTypeId > b.facilityTypeId ? 1 : -1));
};
